import React, { FC, SVGProps } from 'react';

export const ExclamationTriangle: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.8263 12.2503L9.15378 0.656864C8.65335 -0.204999 7.34665 -0.232801 6.84622 0.656864L0.173729 12.2503C-0.326708 13.1122 0.312739 14.2243 1.34141 14.2243H14.6586C15.6873 14.2243 16.3267 13.14 15.8263 12.2503ZM8.0139 9.83153C8.70895 9.83153 9.2928 10.4154 9.2928 11.1104C9.2928 11.8333 8.70895 12.3893 8.0139 12.3893C7.29105 12.3893 6.73501 11.8333 6.73501 11.1104C6.73501 10.4154 7.29105 9.83153 8.0139 9.83153ZM6.79061 5.2442C6.76281 5.04959 6.92962 4.88277 7.12424 4.88277H8.87576C9.07038 4.88277 9.23719 5.04959 9.20939 5.2442L9.01478 9.02528C8.98697 9.21989 8.84796 9.3311 8.68115 9.3311H7.31885C7.15204 9.3311 7.01303 9.21989 6.98523 9.02528L6.79061 5.2442Z"
        fill="#C9311A"
      />
    </svg>
  );
};
